import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  Button, Card, Table, Icon,
} from 'semantic-ui-react';

function IdeaCompanyVerification({ idea, report }) {
  if (!report || !idea) return null;
  return (
    <Card.Group centered>
      <Card raised fluid color="green">
        <Card.Content textAlign="center">
          <Card.Header>
            <Icon name="check circle" color="green" />
            {' '}
            Company successfully found
          </Card.Header>
          <Table basic="very">
            <Table.Row>
              <Table.HeaderCell collapsing>Name</Table.HeaderCell>
              <Table.Cell>{report.companyName}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell collapsing>Registration</Table.HeaderCell>
              <Table.Cell>{report.companyNumber}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell collapsing>Address</Table.HeaderCell>
              <Table.Cell>{report.companyAddress}</Table.Cell>
            </Table.Row>
            {report.companyVatNumber
              && (
              <Table.Row>
                <Table.HeaderCell collapsing>VAT number</Table.HeaderCell>
                <Table.Cell>{report.companyVatNumber}</Table.Cell>
              </Table.Row>
              )
            }
          </Table>
        </Card.Content>
        {report.reportUrl
          && (
          <Card.Content extra>
            <Button as="a" href={report.reportUrl || report.tempReportUrl} target="_blank" rel="noopener noreferrer" download="report.pdf" fluid color="blue" icon="download" content="Download report" />
          </Card.Content>
          )
        }
      </Card>
    </Card.Group>
  );
}

export default withTranslation()(IdeaCompanyVerification);
